import React, { useState } from 'react';
import { Radar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
} from 'chart.js';
import { IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend,ChartDataLabels);

const RotacionPersonalBar = ({ selectedIndustries = [], onBarClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);

  const fixedLabels = ['Manufactura', 'Salud/Farmacéutica', 'Construcción', 'Alimentos', 'Automotriz', 'Retail', 'Servicios logísticos'];

  const forecastAccuracy2023 = {
    'Manufactura': 84,
    'Salud/Farmacéutica': 0,
    'Construcción': 78,
    'Alimentos': 81,
    'Automotriz': 90,
    'Retail': 72,
    'Servicios logísticos': 73,
  };

  const labels = selectedIndustries.length > 0 ? selectedIndustries : fixedLabels;
  const dataValues = labels.map((label) => forecastAccuracy2023[label]);

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Precisión de Pronóstico (%) - 2023',
        data: dataValues,
        backgroundColor: 'rgba(65, 105, 225, 0.3)', // Azul translúcido
        borderColor: 'rgba(65, 105, 225, 1)',
        pointBackgroundColor: 'rgba(65, 105, 225, 1)',
        borderWidth: 2,
        pointRadius: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      r: {
        beginAtZero: true,
        max: 100,
        ticks: {
          stepSize: 10,
          font: { size: 12 },
          callback: (value) => `${value}%`,
        },
        pointLabels: {
          font: { size: 13 },
        },
        grid: {
          color: '#ccc',
        },
        angleLines: {
          color: '#bbb',
        },
      },
    },
    plugins: {
      legend: {
        position: 'top',
        labels: {
          font: { size: 14 },
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.label}: ${context.raw}%`;
          },
        },
      },
      datalabels: {
        color: '#000',
        font: {
          weight: 'bold',
          size: 13,
        },
        formatter: (value) => `${value}%`,
        align: 'start',
        offset: 10,
        display: true,
      },
    },
  };
  

  const infoContent = {
    Analisis: 'La precisión de pronóstico en 2023 muestra un desempeño sólido en sectores clave como Automotriz, Manufactura y Alimentos, con resultados destacados que superan el 80%.',
    formula: 'Precisión de pronóstico (%) = 100% − ( |Demanda real − Pronóstico| / Demanda real ) × 100',
    description: 'La precisión del pronóstico es un indicador logístico clave que mide qué tan acertadas son las estimaciones de demanda en comparación con la demanda real. Su objetivo es evaluar la capacidad de una empresa para anticiparse a las necesidades del mercado, lo cual es fundamental para una planeación efectiva de inventario, compras, producción y distribución.',
  };

  return (
    <div style={{ width: '100%', height: '555px', margin: '0 auto' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Radar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
          <p><strong>Análisis:</strong> {infoContent.Analisis}</p>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default RotacionPersonalBar;
